import { DisplayGridColumnSettings } from "./gridColumnSettings.model";

export interface ColumnFilter {
  column: DisplayGridColumnSettings;
  operator: FilterOperator;
  value?: string | boolean | Date | number;
  valueArray?: Array<string | boolean | Date | number>;
  isEditing?: boolean;
  search: string;
  selectedUnit?: number;
  inherited?: boolean;
}

export interface DrillDownFilterChip {
  key: string;
  label: string;
}

export interface QuickFilter {
  key: string;
  label: string;
  description: string;
  value: string;
}

export interface QuickFilterToggle {
  key: string;
  isOn: boolean;
}

export const FilterOperator = {
  Contains: 'contains',
  StartsWith: 'startsWith',
  IsEmpty: 'isEmpty',
  IsNotEmpty: 'isNotEmpty',
  Equal: 'is',
  LessThan: 'isBefore',
  GreaterThan: 'isAfter',
  LessThanOrEqual: 'isOnOrBefore',
  GreaterThanOrEqual: 'isOnOrAfter',
  Between: 'isBetween',
  RelativeToToday: 'isRelativeToToday'
} as const;

export type FilterOperator = typeof FilterOperator[keyof typeof FilterOperator];